import { WritableComputedRef } from "vue";
import { createI18n, I18n } from "vue-i18n";
import { getEnvVar } from "@/utils/env";
import {
  getCurrentLanguage,
  LANG,
  numberFormat,
  dateTimeFormats,
} from "vacv-common";
import spa_en from "./locales/en.json";
import spa_fr from "./locales/fr.json";
import vacv_en from "vacv-components/locales/en.json";
import vacv_fr from "vacv-components/locales/fr.json";

// merge text copy from vacv-components into this project
// local text overrides the text in vacv-components
const localesMerged = {
  en: { ...vacv_en, ...spa_en },
  fr: { ...vacv_fr, ...spa_fr },
};

const i18n = createI18n({
  legacy: false,
  locale: getCurrentLanguage(),
  fallbackLocale: getEnvVar("VITE_I18N_FALLBACK_LOCALE") || "en",
  globalInjection: true,
  messages: localesMerged,
});
i18n.global.setNumberFormat("en", numberFormat);
i18n.global.setNumberFormat("fr", numberFormat);
i18n.global.setDateTimeFormat("en", dateTimeFormats.en);
i18n.global.setDateTimeFormat("fr", dateTimeFormats.fr);

export default i18n;

export const getLanguages = (supportedLanguages: string): Array<LANG> => {
  return supportedLanguages
    ? (supportedLanguages.split(" ") as Array<LANG>)
    : [LANG.en];
};

/**
 * Set the locale of the global Vuei18n object to the specified locale
 * @param { string } lang Language to be set. Type of LANG.
 */
export const setLocale = (
  i18n: I18n,
  lang: LANG,
  supportedLanguages: string
): void => {
  const languages = getLanguages(supportedLanguages);
  if (languages && languages.indexOf(lang) > -1) {
    (i18n.global.locale as WritableComputedRef<string>).value = lang as string;
  }
};
